import type { RewardsState } from '@swf/core/models/rewards';
import type { EffectParams, ModelConfig, Slicer } from '@swf/core/store';

interface RewardsExchangeModel extends ModelConfig<RewardsExchangeState> {
  reducers: typeof reducers;
  selectors: typeof selectors;
  effects: typeof effects;
}

export interface RewardsExchangeState {
  showNotification: boolean;
  exchangeActionDisabled: boolean;
}

const reducers = {
  disableExchange: (state: RewardsExchangeState) => ({ ...state, exchangeActionDisabled: true }),
  showNotification: (state: RewardsExchangeState, payload: boolean) => ({
    ...state,
    showNotification: payload
  }),
  onExchangeSuccess: (state: RewardsExchangeState) => ({
    ...state,
    exchangeActionDisabled: false
  })
};

const effects = {
  async exchange(payload: undefined, { dispatch, request }: EffectParams) {
    dispatch.rewardsExchange.disableExchange();
    await request<RewardsState>({
      service: '/api/v1-preview/cvlbar/exchange',
      method: 'POST'
    });
    dispatch.rewardsExchange.showNotification(true);
    dispatch.rewardsExchange.onExchangeSuccess();
  }
};

const selectors = (slice: Slicer<RewardsExchangeState>) => ({
  get() {
    return slice((state) => state || {});
  }
});

const rewardsExchange: RewardsExchangeModel = {
  state: {
    showNotification: false,
    exchangeActionDisabled: false
  },
  reducers,
  selectors,
  effects
};

export default rewardsExchange;
